import { render, staticRenderFns } from "./voyage.vue?vue&type=template&id=123e0f03&scoped=true"
import script from "./voyage.vue?vue&type=script&lang=js"
export * from "./voyage.vue?vue&type=script&lang=js"
import style0 from "./voyage.vue?vue&type=style&index=0&id=123e0f03&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123e0f03",
  null
  
)

export default component.exports